import { useClient } from 'Data/Api.js'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import query from './query.graphql.js'

export function useOnAutocompleteAction(props) {
  let change = useDataChange({
    context: 'editor',
    path: 'note_template_url',
    viewPath: props.viewPath,
  })

  return function onAutocompleteAction(url) {
    change(url)
  }
}

export function useOnAutocompleteFetch(props) {
  let client = useClient()
  let organization_id = useDataValue({
    context: 'tab',
    path: 'selected.location_id',
    viewPath: props.viewPath,
  })

  return async function onAutocompleteFetch(pattern) {
    let response = await client
      .query(query, { organization_id, pattern: `%${pattern}%` })
      .toPromise()

    return response?.data?.notes_templates || []
  }
}
